var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVisibilityOffBlack24Dp = function SvgVisibilityOffBlack24Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L24,0 L24,24 L0,24 L0,0 Z M0,0 L24,0 L24,24 L0,24 L0,0 Z M0,0 L24,0 L24,24 L0,24 L0,0 Z M0,0 L24,0 L24,24 L0,24 L0,0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,6 C15.79,6 19.17,8.13 20.82,11.5 C20.23,12.72 19.4,13.77 18.41,14.62 L19.82,16.03 C21.21,14.8 22.31,13.26 23,11.5 C21.27,7.11 17,4 12,4 C10.73,4 9.51,4.2 8.36,4.57 L10.01,6.22 C10.66,6.09 11.32,6 12,6 Z M10.93,7.14 L13,9.21 C13.57,9.46 14.03,9.92 14.28,10.49 L16.35,12.56 C16.43,12.22 16.490037,11.86 16.490037,11.49 C16.5,9.01 14.48,7 12,7 C11.63,7 11.28,7.05 10.93,7.14 Z M2.01,3.87 L4.69,6.55 C3.06,7.83 1.77,9.53 1,11.5 C2.73,15.89 7,19 12,19 C13.52,19 14.98,18.71 16.32,18.18 L19.74,21.6 L21.15,20.19 L3.42,2.45 L2.01,3.87 Z M9.51,11.37 L12.12,13.98 C12.08,13.99 12.04,14 12,14 C10.62,14 9.5,12.88 9.5,11.5 C9.5,11.45 9.51,11.42 9.51,11.37 L9.51,11.37 Z M6.11,7.97 L7.86,9.72 C7.63,10.27 7.5,10.87 7.5,11.5 C7.5,13.98 9.52,16 12,16 C12.63,16 13.23,15.87 13.77,15.64 L14.75,16.62 C13.87,16.86 12.95,17 12,17 C8.21,17 4.83,14.87 3.18,11.5 C3.88,10.07 4.9,8.89 6.11,7.97 Z",
    fill: "#000000",
    fillRule: "nonzero"
  })))));
};

export default SvgVisibilityOffBlack24Dp;